import styled from '@emotion/styled'
import { createPropFilter } from '@news-mono/web-common'
import { breakpoint, calcRem, metrics } from '../../../__styling'

interface Layout {
    className?: string
}

export const StyledInlineContentCardsContainer = styled('div', {
    shouldForwardProp: createPropFilter<Layout>()([]),
})<Layout>(({}) => [
    {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridGap: `${calcRem(
            metrics.sevennews.margins.sm,
            metrics.sevennews.margins.gridGap,
        )}`,

        [breakpoint('xxs')]: {
            gridTemplateColumns: '1fr 1fr',
        },
    },
])
